import { Icon } from '@breezeventures/ui-kit/next/icon';
import cn from 'classnames';

import SortInactiveIcon from '../icons/sort-inactive.svg?react';
import type { SortDirection } from '../lib/types';

type Props = {
  active?: boolean;
  direction?: SortDirection;
};

export const SortIndicator = ({
  active = false,
  direction = 'desc',
}: Props) => {
  if (!active) {
    return <SortInactiveIcon aria-hidden className="shrink-0" />;
  }

  return (
    <Icon
      name="arrow-down"
      size={24}
      version="v1"
      aria-hidden
      className={cn(
        'size-4 shrink-0 text-primary transition-transform duration-150',
        direction === 'asc' && '-scale-y-100'
      )}
    />
  );
};
